import { compact, map } from 'lodash';
import RiskInsuranceRequirementsApplicant from './RiskInsuranceRequirementsApplicant';
import RiskInsuranceRequirementsNatureOfServiceSought from './RiskInsuranceRequirementsNatureOfServiceSought';
import RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues from './RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues';
import type { IRiskInsuranceRequirements } from './RiskInsuranceRequirements.interface';

export default class RiskInsuranceRequirements implements IRiskInsuranceRequirements {
  applicants: Array<RiskInsuranceRequirementsApplicant>;
  natureOfServiceSought: RiskInsuranceRequirementsNatureOfServiceSought;
  assistanceInIdentifyingInsuranceIssues: RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues;

  static build = (data: IRiskInsuranceRequirements) => new RiskInsuranceRequirements(data);
  static blank = () => new RiskInsuranceRequirements();

  /**
   * Constructor
   * @param {IRiskInsuranceRequirements} data
   */
  constructor(data?: IRiskInsuranceRequirements) {
    this.applicants = map(
      compact(data?.applicants),
      (obj) => new RiskInsuranceRequirementsApplicant(obj)
    );
    this.natureOfServiceSought = new RiskInsuranceRequirementsNatureOfServiceSought(
      data?.natureOfServiceSought
    );
    this.assistanceInIdentifyingInsuranceIssues = new RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues(
      data?.assistanceInIdentifyingInsuranceIssues
    );
  }
}
